module.exports = "https://p.cds.unp.clasificados.pe/profile-default.d69ef40a819d88b7b1a96d25ce0d7547.png";